module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Code-e199b572314afaed125ab8de551fb7c0.svg";